// extracted by mini-css-extract-plugin
module.exports = {"section":"things-to-know_section__ARzLF","title":"things-to-know_title___Dw3_"};